import { render, staticRenderFns } from "./DashboardNavbarNotifications.vue?vue&type=template&id=0a277d29"
import script from "./DashboardNavbarNotifications.vue?vue&type=script&lang=js"
export * from "./DashboardNavbarNotifications.vue?vue&type=script&lang=js"
import style0 from "./DashboardNavbarNotifications.vue?vue&type=style&index=0&id=0a277d29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports